import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ModalService } from '@purespectrum1/ui/modal';
import {
  ManualFix,
  Reconcilation,
} from '../../interfaces/adjustments-reconciliation-service.interface';
import { AdjustmentsReconciliationService } from '../../services/adjustments-reconciliation/adjustments-reconciliation-service.service';
import { AdjustmentModalComponent } from '../adjustment-modal/adjustment-modal.component';
import { Constants } from '../manage-reconcile-constants';

@Component({
  selector: 'ps-ui-adjustment-table',
  templateUrl: './adjustment-table.component.html',
  styleUrls: ['./adjustment-table.component.css'],
})
export class AdjustmentTableComponent implements OnChanges {
  @Input() adjustmentReconciliatonRecord!: Array<Reconcilation>;
  @Input() adjustmentManualFixRecord!: Array<ManualFix>;
  @Input() userId!: number;
  @Input() userName: string = '';
  @Input() operationType: string = '';
  @Input() showDownloadReportButtoonInRecon: boolean = false;
  @Input() showDownloadTemplateText: boolean = false;
  @Input() showBackToDashboardButton: boolean = false;
  isDisableUpload: boolean = true;
  fileName: string = '';
  file!: File;
  adjustmentReportStatus: boolean = true;
  isLiveReconciliation: boolean = false;
  liveOption = Constants.LIVE_RECO_STATUS_OPTIONS;

  constructor(
    private _modal: ModalService,
    private _adjustmentReconciliationService: AdjustmentsReconciliationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.operationType &&
      changes.operationType.previousValue !== changes.operationType.currentValue
    ) {
      this.isLiveReconciliation =
        this.operationType === Constants.OPERATION_TYPES.LIVE;
    }
  }

  downloadAdjustmentReport(adjustmentId: string) {
    this.adjustmentReportStatus = false;
    const url_link =
      this._adjustmentReconciliationService.getAdjustmentsReport(adjustmentId);
    window.open(url_link, '_blank');
    this.adjustmentReportStatus = true;
  }

  public formatReconType(recType: string, desiredStatus: number): string {
    const reconTypeMapping: { [key: string]: { [key: number]: string } } = {
      LIVE_RECONCILIATION: {
        33: 'Rejects',
        21: 'Complete',
      },
    };

    return reconTypeMapping[recType]?.[desiredStatus] || 'Accept';
  }

  openStatusModal(
    summary: object,
    id: Array<number>,
    type: string,
    status: boolean,
    adjustmentId: string,
    fileName?: any,
    user?: string,
    invoicedSurveys: Array<number> = []
  ) {
    this._modal.open(AdjustmentModalComponent, {
      data: {
        summary,
        id,
        type,
        status,
        adjustmentId,
        fileName,
        user,
        invoicedSurveys,
      },
    });
  }
}
